import { render } from "./Ending-Screen.vue?vue&type=template&id=e4389494&scoped=true&bindings={}"
import script from "./Ending-Screen.vue?vue&type=script&lang=js"
export * from "./Ending-Screen.vue?vue&type=script&lang=js"

import "./Ending-Screen.vue?vue&type=style&index=0&id=e4389494&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e4389494"

export default script